(function () {
  angular
    .module('MktzapApp.Controllers')
    .requires

  angular.module('MktzapApp.Controllers')
    .controller('ReportsBadwordsConfigController', reports);

  reports.$inject = ['$scope', '$http', '$timeout', 'ngTableParams', 'NotificationService', 'CompanyService', '$rootScope', 'UserService',];

  function reports ($scope, $http, $timeout, ngTableParams, NotificationService, CompanyService, $rootScope, UserService) {
    var vm = this;
    $scope.vm = vm;

    vm.loading = false;
    vm.profile_type = null;

    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    };

    vm.dateSelected = function (type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
      }
    };

    vm.download = function () {
      $http.get(frontUrl + '/reports/badword-report', {
        params: {
          filters: vm.filters
        }
      })
      .then(function ({ data, status, headers, config }) {
          if (data.success === false) {
            NotificationService.warningHandler(data, data.error_message);
            return false;
          }

          var filename = headers('Mktzap-Filename') || 'relatorio-palavras-inapropriadas.csv';

          var anchor = angular.element('<a/>');
          anchor.css({ display: 'none' }); // Make sure it's not visible
          angular.element(document.body).append(anchor); // Attach to document

          var blob = new Blob([data], { type: 'text/csv' });
          var csvUrl = URL.createObjectURL(blob);
          console.log(blob)

          anchor.attr({
            href: csvUrl,
            target: '_self',
            download: filename
          })[0].click();

          anchor.remove(); // Clean it up afterwards
          URL.revokeObjectURL(csvUrl); // Clean memory blob
      }).catch(function ({ data, status, headers, config }) {
        console.log(data)
        NotificationService.warningHandler(data, 'Erro ao gerar relatório.');
      })
      }
  }
})();
